(ns dre.components.list
  (:require
   ["antd" :refer [List]]
   [applied-science.js-interop :as j]
   [dre.i18n.views :refer [tr]]
   [reagent.core :as r]))

(defn collapsable-list
  [_items _init-num-elements]
  (let [collapsed? (r/atom true)]
    (fn [items init-num-elements]
      (let [[head rest] (if (= init-num-elements -1)
                          [items []]
                          (split-at init-num-elements items))
            show-more? (seq rest)
            m-items (if @collapsed?
                    (vec head)
                    items)
            m-items (cond
                      (not show-more?)
                      m-items
                      (and @collapsed? show-more?)
                      (conj m-items {:content (r/as-element [:a {:on-click #(reset! collapsed? (not @collapsed?))} [tr "Show more"] " (" (count rest) ")"])})
                      :else
                      (conj m-items {:content (r/as-element [:a {:on-click #(reset! collapsed? (not @collapsed?))} [tr "Show less"]])}))]
        [:> List
         {:dataSource m-items
          :renderItem (fn [item]
                        (let [actions (j/get item :actions)
                              content (j/get item :content)]
                          (r/as-element [:> List.Item
                                       {:actions actions}
                                       content])))}]))))